module.exports = __webpack_public_path__ + "img/workshops.0b6538fb.png";